import React from "react";
import {FaArrowRight, FaFileContract, FaPaw} from "react-icons/fa";
import "./styles.css";

const defaultLinks = [
	{label: "Privacy Policy", href: "/privacy"},
	{label: "Terms of Service", href: "/terms"},
	{label: "End-User License", href: "/eula"},
	{label: "Child Safety", href: "/child-safety"},
];

const ContentPage = ({
	icon,
	eyebrow,
	title,
	summary,
	updated,
	children,
	asideTitle = "Legal center",
	asideText = "Clear information about your rights, responsibilities, and how Barkr works.",
	links = defaultLinks,
}) => (
	<main className="content-page">
		<section className="content-page__hero">
			<div className="content-page__orb content-page__orb--one"/>
			<div className="content-page__orb content-page__orb--two"/>
			<div className="content-page__shell content-page__hero-inner">
				<div className="content-page__icon">{icon || <FaFileContract/>}</div>
				<p className="content-page__eyebrow">{eyebrow}</p>
				<h1>{title}</h1>
				<p className="content-page__summary">{summary}</p>
				{updated && <p className="content-page__updated">{updated}</p>}
			</div>
		</section>

		<section className="content-page__body">
			<div className="content-page__shell content-page__layout">
				<aside className="content-page__aside">
					<div className="content-page__aside-mark"><FaPaw/></div>
					<h2>{asideTitle}</h2>
					<p>{asideText}</p>
					<nav aria-label={asideTitle}>
						{links.map(link => (
							<a key={link.href} href={link.href}>
								{link.label}<FaArrowRight/>
							</a>
						))}
					</nav>
				</aside>
				<article className="content-page__article">{children}</article>
			</div>
		</section>
	</main>
);

export default ContentPage;
